import { render } from "./demo-day-blurred-auction-information.vue?vue&type=template&id=1ca576d3"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__